import { ServicesDataContext, ServicesDataContextType } from "modules/cached-data/src/services-data/services-data-context"
import { useContext } from "react"

export function useServicesData (): ServicesDataContextType {
    return useContext( ServicesDataContext )
}
